import React from 'react';
import PropTypes from 'prop-types';

import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {ShopIcon} from '@amblique/king-living/app/components/icons';

/**
 * Shop Button
 * @param {Object} props
 * @param {Function} props.onClick
 */
const ShopButton = ({
  text,
  onClick,
  showLabelDesktop = true,
  showLabelMobile = false,
  ...props
}) => {
  const styles = useMultiStyleConfig('ShopButton', {});

  return (
    <Box
      {...styles.shopButton}
      as="button"
      type="button"
      onClick={onClick}
      {...props}
    >
      <Box {...styles.shopIcon}>
        <ShopIcon />
      </Box>
      {text ? (
        <Text
          {...styles.shopButtonText}
          display={{
            base: showLabelMobile ? 'flex' : 'none',
            md: showLabelDesktop ? 'flex' : 'none',
          }}
        >
          {text}
        </Text>
      ) : null}
    </Box>
  );
};

ShopButton.propTypes = {
  onClick: PropTypes.func,
  showLabelDesktop: PropTypes.bool,
  showLabelMobile: PropTypes.bool,
  text: PropTypes.string,
};

export default ShopButton;
